module.exports = __webpack_public_path__ + "img/space4.a6bd0440.jpg";